export enum AnalyticsEvent {
  PartnerBannerPressed = "PartnerBanner Pressed",
  PartnershipPrimaryCTAPressed = "Partnership Primary CTA Pressed",
  PartnershipSecondaryCTAPressed = "Partnership Secondary CTA Pressed",
  // The Welcome screen renders its CTAs outside the layout, so these are fired
  // by hand — the names match what the layout emits for every other screen.
  // Primary is "Create an account", secondary is "I have an account".
  AuthPrimaryCTAPressed = "Auth Primary CTA Pressed",
  AuthSecondaryCTAPressed = "Auth Secondary CTA Pressed",
  EntryGetStartedPrimaryCTAPressed = "EntryGetStarted Primary CTA Pressed",
  EntryNamePrimaryCTAPressed = "EntryName Primary CTA Pressed",
  EntryPreferredNamePrimaryCTAPressed = "EntryPreferredName Primary CTA Pressed",
  EntryEmailPrimaryCTAPressed = "EntryEmail Primary CTA Pressed",
  BankLinkingSuccess = "BankLinking Success",
  BankLinkingExit = "BankLinking Exit",
  DashboardViewed = "Dashboard Viewed",
  BackButtonPressed = "Back Button Pressed",
  AuthRoutePhoneCTAPressed = "AuthRoute Phone CTA Pressed",
  AuthRouteGoogleCTAPressed = "AuthRoute Google CTA Pressed",
  AuthRouteEmailCTAPressed = "AuthRoute Email CTA Pressed",
  // The two ends of the funnel, and the only events wired to paid-ad
  // conversions. SignUp is the lead: an account now exists, but the user has
  // not finished onboarding. UserRegistrationComplete is the final conversion,
  // fired once when the congratulatory screen is shown.
  SignUp = "Sign Up",
  UserRegistrationComplete = "UserRegistration Complete",
  PerformanceBreakdownChartRendered = "Performance Breakdown Chart Rendered",
  PerformanceBreakdownChartError = "Performance Breakdown Chart Error",
  PromoCodeApplied = "Promo Code Applied",
  PromoCodeError = "Promo Code Error",
  // These two screens render their CTA outside OnboardingLayout/EntryStepLayout,
  // so they don't get the layout's automatic `${route} Primary CTA Pressed` —
  // the names here match what the layout would have emitted.
  OnboardingCompletePrimaryCTAPressed = "OnboardingComplete Primary CTA Pressed",
  PartnerExistingAccountPrimaryCTAPressed = "PartnerExistingAccount Primary CTA Pressed",
}
